export default __webpack_public_path__ + "static/media/7.e73f1604.jpg";